<template>
  <div class="admin-view" v-if='hasAdminRole'>
    <permissions-header :title="routeName"/>
    <router-view>
    </router-view>
  </div>
</template>

<script>
import PermissionsHeader from '@/appComponents/permissions/components/Header'

export default {
  components: {
    PermissionsHeader
  },
  beforeMount () {
    if (!this.$store.state.idmAuth.loggedIn) {
      this.$router.replace({name: 'AdminLogin'})
    }
  },
  computed: {
    routeName () {
      return this.$route.name
    },
    hasAdminRole () {
      let r = this.$store.getters.userRoles
      return r && r.hasAdminRole()
    },
    loggedIn () {
      return this.$store.state.idmAuth.loggedIn
    }
  }
}
</script>

<style>
.admin-view {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// AdminView.vue?3fe0e14f